import React from 'react';
import Container from "../../components/container/container-component";
import PieChartWrapper from "../../components/pie-chart-wrapper/pie-chart-wrapper-component";
import FullReportTopWords from '../full-report-top-words/full-report-top-words-container';
import SideContainer from "../../components/side-container/side-container-component";
import Filters from "../filters/filters-container";
import MainContainer from "../../components/main-container/main-container-component";
import FullReportPrimaryOrSentiment from "../full-report-primary-or-sentiment/full-report-primary-or-sentiment-container";
import ReportInfo from "../report-info/report-info-container";

const FullReportComponent = (
  {
    match,
    topWords,
    topWordsLoading,
    sentimentBreakdown,
    sentimentBreakdownLoading,
    primaryEmotionsBreakdown,
    primaryEmotionsBreakdownLoading
  }
) => {
  const { reportName } = match.params;
  return (
    <Container flexDirection="column" justifyContent="flex-start" alignItems="flex-start">

      <SideContainer>
        <Filters />
      </SideContainer>

      <MainContainer>
        <div className="report_info_container">
          <ReportInfo marginBottom />
        </div>
        <div style={{padding: '0 10px'}}>
          {
            reportName === 'top-words' &&
            <PieChartWrapper
              title="Top 10 Words"
              data={topWords}
              valueName="Term"
              value="term"
              svgId="topWords"
              loading={topWordsLoading}
              link="/report/top-words"
              height={230}
              legendHeight="235px"
              minHeight="340px"
            />
          }
          {
            reportName === 'sentiment' &&
            <PieChartWrapper
              title="Sentiment Breakdown"
              data={sentimentBreakdown}
              valueName="Sentiment"
              value="sentiment"
              svgId="sentimentBreakdown"
              loading={sentimentBreakdownLoading}
              link="/report/sentiment"
              height={180}
              minHeight="285px"
              legendHeight="150px"
            />
          }
          {
            reportName === 'primary-emotions' &&
            <PieChartWrapper
              title="Primary Emotions Breakdown"
              data={primaryEmotionsBreakdown}
              valueName="Primary"
              value="primary"
              svgId="primaryEmotionsBreakdown"
              loading={primaryEmotionsBreakdownLoading}
              link="/report/primary-emotions"
              height={230}
              legendHeight="235px"
              minHeight="340px"
            />
          }
          {
            reportName === 'top-words' &&
            <FullReportTopWords />
          }
          {
            reportName === 'primary-emotions' &&
              <FullReportPrimaryOrSentiment primary={true} />
          }
          {
            reportName === 'sentiment' &&
              <FullReportPrimaryOrSentiment />
          }
        </div>
      </MainContainer>

    </Container>
  )
};


export default FullReportComponent;


// WEBPACK FOOTER //
// ./src/modules/full-report-charts/full-report-charts-component.js